import { styled } from 'parkdepot-shared/theme'

const Text = styled<
    'span',
    {
        typography: any
        fontWeight?: number
        marginbottom?: string
        color?: string
        $align?: string
        $fontsize?: string
        $lineHeight?: string
    }
>('span', ({ typography, fontWeight, marginbottom, color, $align, $fontsize, $lineHeight }) => ({
    ...typography,
    fontWeight: fontWeight || 400,
    marginBottom: marginbottom || '0',
    color,
    textAlign: $align || 'left',
    display: 'inline-block',
    ...($fontsize && { fontSize: $fontsize }),
    ...($lineHeight && { lineHeight: $lineHeight })
}))

export default Text
